import { useEffect } from "react";

/**
 * Lightweight per-route SEO hook.
 * Updates document.title, meta description, canonical and og:url on route change.
 */
export default function useSeo({ title, description, path = "/", image }) {
    useEffect(() => {
        const baseUrl = "https://alpen-reinigung.at";
        const fullUrl = `${baseUrl}${path}`;

        if (title) document.title = title;

        const setMeta = (selector, attr, value) => {
            if (!value) return;
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                const [, key, val] = selector.match(/\[(.*?)="(.*?)"\]/) || [];
                if (key && val) el.setAttribute(key, val);
                document.head.appendChild(el);
            }
            el.setAttribute(attr, value);
        };

        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[property="og:url"]', "content", fullUrl);
        setMeta('meta[name="twitter:title"]', "content", title);
        setMeta('meta[name="twitter:description"]', "content", description);
        if (image) {
            setMeta('meta[property="og:image"]', "content", image);
            setMeta('meta[name="twitter:image"]', "content", image);
        }

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", fullUrl);
    }, [title, description, path, image]);
}
